import emailjs from '@emailjs/browser';

/**
 * Send email using EmailJS
 * @param {Object} formRef - React ref to the form element
 * @param {string} templateId - EmailJS template ID
 * @param {Object} options - Additional options
 * @returns {Promise} - Promise that resolves when email is sent
 */
export const sendEmailJS = async (formRef, templateId, options = {}) => {
  const {
    serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID,
    publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
    onSuccess = () => {},
    onError = () => {}
  } = options;

  // Validate required parameters
  if (!serviceId || !templateId || !publicKey) {
    const error = new Error('EmailJS configuration is missing required parameters');
    console.error('EmailJS error:', error);
    onError(error);
    throw error;
  }

  try {
    const result = await emailjs.sendForm(serviceId, templateId, formRef, publicKey);
    onSuccess(result);
    return result;
  } catch (error) {
    console.error('EmailJS error:', error);
    onError(error);
    throw error;
  }
};

